import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { actionCreators } from "store/actions/mymazda"
import { bindAll } from "utils"
import { removeMyMazdaVehicle } from "apis/mymazda"
import { withRadium, DetectCompact } from "higher-order-components"
import { SteppedFlow, Heading, Select, WysiwygContent, LoaderIcon, TickModalIcon } from "components"
import { H3, Space, Button, Modal } from "AtomicComponents"
import { FORM_ERRORS, MYMAZDA_ERRORS } from "constants/errors"
import { isLocalStorageSupported, removeLocal, setLocal } from "apis/persist"

class MyMazdaRemoveVehicleFlow extends Component {
  constructor() {
    super()
    this.state = {
      reason: undefined,
      validation: false,
      isFetching: false
    }
    bindAll(["handleClose", "handleRemoveVehicle", "renderSelectReason", "renderAreYouSure", "renderRemoveSuccess"], this)
  }

  componentDidMount() {
    // clear localStorage
    removeLocal("addRemoveVehicleLastStep")
  }

  handleClose() {
    if (this.state.isFetching) return
    this.props.onClose()
  }

  handleRemoveVehicle(setStep) {
    const {
      vehicle: { nameplate, registrationNumber }
    } = this.props
    this.setState({ isFetching: true })
    removeMyMazdaVehicle(this.props.removeVehicleEndpoint, {
      notes: this.state.reason ? this.state.reason.value : "none",
      vin: this.props.vehicle.vin
    })
      .then(() => {
        this.props.flashMessage(
          MYMAZDA_ERRORS.VEHICLE_REMOVE_SUCCESS({ nameplate, registrationNumber }),
          "SUCCESS"
        )
        isLocalStorageSupported() && setLocal("addRemoveVehicleLastStep", JSON.stringify(true))
        setStep(2)
        // this.props.onClose()
        // this.props.refreshCurrentRoute() // this will cause the modal to remount, closing it.
      })
      .catch(error => {
        this.props.flashMessage(
          MYMAZDA_ERRORS.VEHICLE_REMOVE_FAILED({
            nameplate,
            registrationNumber,
            error: error.message
          }),
          "ERROR",
          0
        )
        this.props.onClose()
      })
  }
  renderSelectReason({ nextStep }) {
    const {
      removeDescription,
      vehicle: { nameplate, bodyStyle, registrationNumber }
    } = this.props
    return (
      <div style={styles.slide(this.props.compact)}>
        <H3 withDetails>Remove a Vehicle</H3>
        <Space />
        <WysiwygContent
          replaceVariables={{
            nameplate,
            bodyStyle,
            registrationNumber: registrationNumber || "Registration number not available"
          }}
          xmlString={removeDescription} />
        <Select
          label="Reason for removal"
          value={this.state.reason}
          required
          onChange={reason => {
            this.setState({ reason, validation: false })
          }}
          message={this.state.validation ? FORM_ERRORS.SELECT_REQUIRED : ""}
          options={["Private Sale", "Trade in", "Write off/recall", "Other"].map(value => ({
            name: value,
            value
          }))} />
        <Space />
        <Space />
        <Button
          fullWidth
          styleName={"black"}
          onClick={() => {
            this.setState(
              {
                validation: true
              },
              this.state.reason && nextStep
            )
          }}
          disabled={!this.state.reason}>
          Remove vehicle
        </Button>
      </div>
    )
  }

  renderAreYouSure({ setStep }) {
    return (
      <div style={styles.slide(this.props.compact)}>
        <H3 withDetails>Remove Vehicle</H3>
        <Space />
        <Space />
        <WysiwygContent xmlString={this.props.removeConfirmationDescription} />
        <Button
          fullWidth
          styleName={"black"}
          loading={this.state.isFetching}
          onClick={() => { this.handleRemoveVehicle(setStep) }}
          gtm={{
            category: "MyMazda - Manage Vehicles",
            action: `Remove vehicle - clicked "REMOVE VEHICLE"`
          }}>
          Yes, remove Vehicle
        </Button>
        <Space />
        <Button fullWidth styleName={"blackOutlined"} onClick={this.handleClose}>
          Cancel
        </Button>
      </div>
    )
  }

  renderRemoveSuccess() {
    const { compact, vehicle: { nameplate, registrationNumber } } = this.props

    return (
      <div style={styles.slide(compact)}>
        <TickModalIcon style={{ width: "2.25em", height: "2.25em", margin: "0 auto 1em" }} />
        <H3>Vehicle removed</H3>
        <WysiwygContent xmlString={`${MYMAZDA_ERRORS.VEHICLE_REMOVE_SUCCESS({ nameplate, registrationNumber })}`} theme={"light"} style={{ margin: "1em 0" }} />
        <Button
          onClick={() => { window.location.reload() }}
          fullWidth
          styleName="black"
        >
          Continue
        </Button>
      </div>
    )
  }
  render() {
    return <SteppedFlow>{[this.renderSelectReason, this.renderAreYouSure, this.renderRemoveSuccess]}</SteppedFlow>
  }
}

const styles = {
  slide: compact => ({
    padding: compact ? "0" : "3em",
    textAlign: "center"
  })
}

MyMazdaRemoveVehicleFlow.propTypes = {
  vehicle: PropTypes.shape({
    nameplate: PropTypes.string,
    bodyStyle: PropTypes.string,
    registrationNumber: PropTypes.string,
    vin: PropTypes.string
  }),
  removeVehicleEndpoint: PropTypes.string,
  removeDescription: PropTypes.string,
  removeConfirmationDescription: PropTypes.string,
  onClose: PropTypes.func,
  compact: PropTypes.bool,
  refreshCurrentRoute: PropTypes.func,
  flashMessage: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  flashMessage: (...args) => dispatch(actionCreators.addFlashMessage(...args)),
  refreshCurrentRoute: () => dispatch(actionCreators.refreshCurrentRoute())
})

export default withRadium(
  connect(
    null,
    mapDispatchToProps
  ),
  DetectCompact()
)(props => (
  <Modal open width={"650px"} handleClose={props.onClose}>
    <MyMazdaRemoveVehicleFlow {...props} />
  </Modal>
))



// WEBPACK FOOTER //
// ./src/containers/mymazda/manage-vehicle-flows/remove-vehicle.jsx